//=================================================================================================
// SCRIPTING
//=================================================================================================

<script>
import Vue       from 'vue';
import Component from 'vue-class-component';

const EXT_LINK_FEATURED_1 = 'https://www.youtube-nocookie.com/embed/5fNolUmhD1k'
const EXT_LINK_FEATURED_2 = 'https://www.youtube-nocookie.com/embed/dGUnnZya0dk';

@Component({})
export default class About extends Vue {
	EXT_LINK_FEATURED_1 = EXT_LINK_FEATURED_1;
	EXT_LINK_FEATURED_2 = EXT_LINK_FEATURED_2;
}
</script>

//=================================================================================================
// TEMPLATING
//=================================================================================================

<template>
<section id="about" class="g--flowdown g--center-content g--fullscreen">
	<div class="s--navbar-gap"></div>

	<div class="r--content">
		<h2>Welcome to Tropical Tower Wars</h2>
		<p class="s--wide-text">
			TTW is a fast-paced, multiplayer game combining the best of tower defence and
			real-time strategy. Pick from a growing selection of unique factions to upgrade and defend your
			region, and summon onslaughts of units to defeat your enemies. Play for free on Dota 2 custom games,
			standalone coming 2023.
		</p>

		<h3>Featured Videos</h3>

		<div class="featured-videos">
			<div class="s--action-box video-frame">
				<div class="ratio">
					<div class="video-border s--overlay">
						<iframe
							:src        = "EXT_LINK_FEATURED_1"
							width       = "100%"
							height      = "100%"
							frameborder = "0"
							allow       = "clipboard-write; encrypted-media; picture-in-picture"
							allowfullscreen
						></iframe>
					</div>
				</div>
			</div>

			<div class="s--action-box video-frame">
				<div class="ratio">
					<div class="video-border s--overlay">
						<iframe
							:src        = "EXT_LINK_FEATURED_2"
							width       = "100%"
							height      = "100%"
							frameborder = "0"
							allow       = "clipboard-write; encrypted-media; picture-in-picture"
							allowfullscreen
						></iframe>
					</div>
				</div>
			</div>
		</div>

		<p><router-link :to="{ name: 'Feature' }">Want to feature your TTW video? Click here!</router-link></p>
	</div>

	<div class="s--footer-gap"></div>
</section>
</template>

//=================================================================================================
// STYLING
//=================================================================================================

<style lang="scss" scoped>
@import '../assets/scss/colour.scss';
@import '../assets/scss/responsive.scss';

.featured-videos {
	display                     : flex;
	flex-direction              : row;
	flex-wrap                   : wrap;
	margin                      : -10px;
}

.video-frame {
	padding                     : 10px;
	flex                        : 1 1 0;

	@media only screen and (max-width: ($r--md - 1px)) {
		min-width                   : 50%;
	}
}

.ratio {
	position                    : relative;
	width                       : 100%;
	padding-top                 : 56.25%; /* 16:9 */
	background-color            : black;
}

.video-border {
	border                      : 1px solid black;
}
</style>
